import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
//  {
//     path: '/career',
//     name: 'Career',
//     component: () => import('../views/Career.vue')
//  },
  {
    path: '/projects/1',
    name: 'Project 1',
    component: () => import('../views/Project1.vue')
  },
   {
    path: '/projects/2',
    name: 'Project 2',
    component: () => import('../views/Project2.vue')
  },
   {
    path: '/projects/3',
    name: 'Project 3',
    component: () => import('../views/Project3.vue')
  }
]

const router = new VueRouter({
  routes: routes,
  scrollBehavior (to) {
    if (to.hash) {
      return window.scrollTo({ 
        top: document.querySelector(to.hash).offsetTop, 
        behavior: 'smooth' 
      })
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
